module.exports = __webpack_public_path__ + "img/英文版_库尔_湖北.bb6d4093.webp";